var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column account-info mb-5 mb-lg-0"},[_c('Description',{staticClass:"mb-5 d-flex flex-column"}),_c('Matches')],1)}
var staticRenderFns = []

export { render, staticRenderFns }